<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>
  export default {
    name : 'app'
  }
</script>

<style>
@import'~bootstrap/dist/css/bootstrap.css';
@import './assets/style.css';
@import './assets/customer_style.css';
</style>
